import { makeStyles } from '@material-ui/core';
import Typography from 'components/Typography';
import config from 'config/common';
import { FeatureFlags } from 'config/featureFlags.constants';
import { isTablet } from 'helpers/device_helper';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { formatLinkLng } from 'helpers/formatLinkLng';

const useStyles = makeStyles((theme) => ({
    fixed_bottom_text: () => ({
        fontSize: '15px',
        flex: '0 0 auto',
        position: 'relative',
        backgroundColor: 'white',
        color: 'black',
        padding: `2rem`,
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        '& > div': {
            '& > p': {
                marginBottom: '1rem',
                '&:last-child': {
                    marginBottom: '0',
                },
            },
        },
        ...isTablet({
            padding: `2rem 4rem`,
        }),
    }),
    first_text: {
        fontSize: '1.5rem',
        fontWeight: 400,
        lineHeight: '25.5px',
    },
    page_link: {
        '&:link,&:visited': {
            color: '#281283',
            fontWeight: 'bold',
            textDecoration: 'none',
            fontSize: '15px',
        },
    },
    fixed_bottom_text_btn: {
        '&&': {
            position: 'absolute',
            top: 0,
            transform: `translateY(-50%) rotate(0deg)`,
            backgroundColor: theme.palette.primary.main,
            transition: 'all 200ms linear',
            borderRadius: '50%',
            color: theme.palette.primary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
        },
    },
    risk_warning_notice: {
        fontSize: '1.5rem',
        fontWeight: 400,
        lineHeight: '25.5px',
        color: 'red',
    },
}));

export interface DisclaimerProps {}

const DisclaimerEu: React.FunctionComponent<DisclaimerProps> = () => {
    const [cfd_percentage, set_cfd_percentage] = React.useState<string>('');
    const classes = useStyles();

    const {
        i18n: { language },
    } = useTranslation();

    React.useEffect(() => {
        (async () => {
            const config_cfd_percentage = await config.cfd_percentage;
            set_cfd_percentage(config_cfd_percentage);
        })();
    }, []);

    return (
        <div className={classes.fixed_bottom_text}>
            <div>
                <Typography className={classes.first_text}>
                    <Trans
                        i18nKey={`common:fixed_bottom_text`}
                        values={{ cfd_percentage }}
                        components={{
                            c_link: (
                                <a
                                    className={classes.page_link}
                                    href={formatLinkLng(config.links.warnings_and_disclosures, language)}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    a
                                </a>
                            ),
                        }}
                    />
                </Typography>
                {config.featuresFlags[FeatureFlags.SHOW_UK_DISCLAIMER_NOTICE] && (
                    <Typography className={classes.risk_warning_notice}>
                        <Trans i18nKey={`common:fixed_bottom_text_notice`} />
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default DisclaimerEu;
